import '@core/sentry/instrument'; // Must be first — captures errors during module evaluation
import { createRoot } from 'react-dom/client'
import { initReservationAttribution } from '@shared/utils/reservationSource'
import App from '@app/App'
import './index.css'

// Normalize double slashes in pathname (e.g. //user/account → /user/account).
// Backend email templates sometimes produce URLs with double slashes.
// Must redirect (not replaceState) so the router initializes with the clean URL.
const { pathname } = window.location;
if (pathname.includes('//')) {
  const cleaned = pathname.replace(/\/\/+/g, '/');
  window.location.replace(cleaned + window.location.search + window.location.hash);
}

// Capture UTM params, referrer, and source from the landing URL before
// SPA navigation strips query params. Must run before React renders.
initReservationAttribution();

createRoot(document.getElementById("root")!).render(<App />);
